import React, { useEffect, useState } from 'react';
import axiosInstance from '../../api/axiosInstance';
import './CategoryFilter.css';

interface Category {
  id: number;
  name: string;
  type: string;
}

const CategoryFilter: React.FC<{ onSelect: (catId: number | null) => void }> = ({ onSelect }) => {
  const [categories, setCategories] = useState<Category[]>([]);
  const [selected, setSelected] = useState<number | null>(null);

  useEffect(() => {
    axiosInstance.get('/api/categories?type=main1').then(res => setCategories(res.data));
  }, []);

  return (
    <div className="category-filter-container">
      <button 
        onClick={() => { setSelected(null); onSelect(null); }} 
        className={`filter-chip ${selected === null ? 'active' : ''}`}
      >
        🌟 전체
      </button>
      
      {categories.map(cat => (
        <button 
          key={cat.id} 
          onClick={() => { setSelected(cat.id); onSelect(cat.id); }} 
          className={`filter-chip ${selected === cat.id ? 'active' : ''}`}
        >
          {cat.name}
        </button>
      ))}
    </div>
  );
};

export default CategoryFilter;
